import { dataCopySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCopySolid = /*#__PURE__*/createIcon(dataCopySolid)
export default IconCopySolid
